<template>
  <div class="menu">
    <div class="menu__panel">
      <div class="panel">
        <div class="panel__header menu-sub">
          <p>Past exam questions</p>
        </div>
        <div class="panel__body">
          <div class="panel__content">
            <ul class="items">
              <li class="item car disable">
                <div class="item__inner">
                  <p>2016<br>Written exam A</p>
                </div>
              </li>
              <li class="item car disable">
                <div class="item__inner">
                  <p>2017<br>Written exam A</p>
                </div>
              </li>
              <li class="item car">
                <div class="item__inner" v-on:click="gotoMenuExam2()">
                  <p>2018<br>Written exam A</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="menu__return">
      <div v-on:click="onReturn()" class="modal-box__return">
        <img :src="`${staticPath}img/factory/btn_return.png`">
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import '@/assets/scss/study_menu.scss';

  .menu__panel {
    height: auto;
  }

  .panel__header.menu-sub {

    &::before {
      background-image: url($static-path + 'img/factory/study/icon_exam_wht.png');
    }

    >p {
      padding-left: 6px;
    }
  }

  .item__inner {
    padding: 16px 20px;

    >p {
      line-height: 1.4;
    }
  }
</style>

<script>
  import Constant from '@/constant';

  export default {
    name: 'MenuExam1',

    data() {
      return {
        staticPath: Constant.STATICPATH
      }
    },

    methods: {

      gotoMenuExam2() {
        this.$emit('goto-menu-exam2');
      },

      onReturn() {
        this.$emit('on-return');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Study/MenuExam1.vue